var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7321 14.3182H14.9907L14.7279 14.065C15.8541 12.7518 16.436 10.9603 16.1169 9.05624C15.6758 6.44869 13.4984 4.36639 10.8705 4.04749C6.90061 3.55974 3.55948 6.89891 4.04751 10.8665C4.36661 13.4928 6.45012 15.6689 9.05921 16.1098C10.9644 16.4287 12.757 15.8471 14.0709 14.7216L14.3243 14.9842V15.7252L18.313 19.7116C18.6978 20.0961 19.3266 20.0961 19.7114 19.7116C20.0962 19.327 20.0962 18.6986 19.7114 18.314L15.7321 14.3182ZM10.101 14.3182C7.76405 14.3182 5.87763 12.4329 5.87763 10.0974C5.87763 7.76184 7.76405 5.87653 10.101 5.87653C12.4379 5.87653 14.3243 7.76184 14.3243 10.0974C14.3243 12.4329 12.4379 14.3182 10.101 14.3182Z",
    fill: "#B4B5B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a537a0497d97c465490901abd5d9009c.svg";
export { ForwardRef as ReactComponent };